module.exports = __webpack_public_path__ + "img/contact18.1767c81a.png";